import { render, staticRenderFns } from "./PunchClockWrapper.vue?vue&type=template&id=7a36d944&"
import script from "./PunchClockWrapper.vue?vue&type=script&lang=js&"
export * from "./PunchClockWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports